import React from 'react';
import './Skills.css';

const groups = [
  {
    label: 'Languages',
    items: ['Python', 'JavaScript', 'TypeScript', 'SQL', 'C++', 'C', 'Lisp'],
  },
  {
    label: 'Frameworks & Libraries',
    items: ['React', 'Next.js', 'FastAPI', 'Flask', 'PyTorch', 'OpenCV', 'Pandas', 'NumPy'],
  },
  {
    label: 'Tools',
    items: ['Git', 'Docker', 'Supabase', 'PostgreSQL', 'Node.js', 'Jupyter', 'Excel', 'SAP S/4HANA'],
  },
  {
    label: 'Concepts',
    items: ['Machine Learning', 'Data Science', 'Data Pipelines', 'Computer Vision', 'NLP', 'System Design'],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="skills">
      <div className="container">
        <p className="section-label">Skills</p>
        <h2 className="section-title">What I Work With</h2>
        <div className="skills-grid">
          {groups.map((g) => (
            <div key={g.label} className="skill-group">
              <h3 className="skill-group-label">{g.label}</h3>
              <ul className="skill-list">
                {g.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
